export default __webpack_public_path__ + "static/media/gasTanksRojevas.1b75a492.jpg";